// source: proto/email/email.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var proto_common_crudFields_pb = require('../../proto/common/crudFields_pb.js');
goog.object.extend(proto, proto_common_crudFields_pb);
var proto_common_objectID_pb = require('../../proto/common/objectID_pb.js');
goog.object.extend(proto, proto_common_objectID_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.email.Email', null, global);
goog.exportSymbol('proto.email.Email.SubmissionError', null, global);
goog.exportSymbol('proto.email.Email.SubmissonLease', null, global);
goog.exportSymbol('proto.email.EmailDetails', null, global);
goog.exportSymbol('proto.email.EmailDetails.Content', null, global);
goog.exportSymbol('proto.email.EmailInternalDetails', null, global);
goog.exportSymbol('proto.email.EmailInternalDetails.SendgridParameters', null, global);
goog.exportSymbol('proto.email.NewEmail', null, global);
goog.exportSymbol('proto.email.Recipients', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.email.NewEmail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.email.NewEmail.repeatedFields_, null);
};
goog.inherits(proto.email.NewEmail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.email.NewEmail.displayName = 'proto.email.NewEmail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.email.EmailDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.email.EmailDetails.repeatedFields_, null);
};
goog.inherits(proto.email.EmailDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.email.EmailDetails.displayName = 'proto.email.EmailDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.email.EmailDetails.Content = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.email.EmailDetails.Content, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.email.EmailDetails.Content.displayName = 'proto.email.EmailDetails.Content';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.email.Recipients = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.email.Recipients.repeatedFields_, null);
};
goog.inherits(proto.email.Recipients, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.email.Recipients.displayName = 'proto.email.Recipients';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.email.Email = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.email.Email.repeatedFields_, null);
};
goog.inherits(proto.email.Email, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.email.Email.displayName = 'proto.email.Email';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.email.Email.SubmissionError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.email.Email.SubmissionError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.email.Email.SubmissionError.displayName = 'proto.email.Email.SubmissionError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.email.Email.SubmissonLease = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.email.Email.SubmissonLease, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.email.Email.SubmissonLease.displayName = 'proto.email.Email.SubmissonLease';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.email.EmailInternalDetails = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.email.EmailInternalDetails, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.email.EmailInternalDetails.displayName = 'proto.email.EmailInternalDetails';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.email.EmailInternalDetails.SendgridParameters = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.email.EmailInternalDetails.SendgridParameters, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.email.EmailInternalDetails.SendgridParameters.displayName = 'proto.email.EmailInternalDetails.SendgridParameters';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.email.NewEmail.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.email.NewEmail.prototype.toObject = function(opt_includeInstance) {
  return proto.email.NewEmail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.email.NewEmail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.email.NewEmail.toObject = function(includeInstance, msg) {
  var f, obj = {
    relatedIdsList: jspb.Message.toObjectList(msg.getRelatedIdsList(),
    proto_common_objectID_pb.ObjectID.toObject, includeInstance),
    recipients: (f = msg.getRecipients()) && proto.email.Recipients.toObject(includeInstance, f),
    details: (f = msg.getDetails()) && proto.email.EmailDetails.toObject(includeInstance, f),
    sendAtTime: (f = msg.getSendAtTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    internalDetails: (f = msg.getInternalDetails()) && proto.email.EmailInternalDetails.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.email.NewEmail}
 */
proto.email.NewEmail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.email.NewEmail;
  return proto.email.NewEmail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.email.NewEmail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.email.NewEmail}
 */
proto.email.NewEmail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.addRelatedIds(value);
      break;
    case 2:
      var value = new proto.email.Recipients;
      reader.readMessage(value,proto.email.Recipients.deserializeBinaryFromReader);
      msg.setRecipients(value);
      break;
    case 3:
      var value = new proto.email.EmailDetails;
      reader.readMessage(value,proto.email.EmailDetails.deserializeBinaryFromReader);
      msg.setDetails(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendAtTime(value);
      break;
    case 5:
      var value = new proto.email.EmailInternalDetails;
      reader.readMessage(value,proto.email.EmailInternalDetails.deserializeBinaryFromReader);
      msg.setInternalDetails(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.email.NewEmail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.email.NewEmail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.email.NewEmail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.email.NewEmail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRelatedIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getRecipients();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.email.Recipients.serializeBinaryToWriter
    );
  }
  f = message.getDetails();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.email.EmailDetails.serializeBinaryToWriter
    );
  }
  f = message.getSendAtTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getInternalDetails();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.email.EmailInternalDetails.serializeBinaryToWriter
    );
  }
};


/**
 * repeated common.ObjectID related_ids = 1;
 * @return {!Array<!proto.common.ObjectID>}
 */
proto.email.NewEmail.prototype.getRelatedIdsList = function() {
  return /** @type{!Array<!proto.common.ObjectID>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {!Array<!proto.common.ObjectID>} value
 * @return {!proto.email.NewEmail} returns this
*/
proto.email.NewEmail.prototype.setRelatedIdsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.common.ObjectID=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.ObjectID}
 */
proto.email.NewEmail.prototype.addRelatedIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.common.ObjectID, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.email.NewEmail} returns this
 */
proto.email.NewEmail.prototype.clearRelatedIdsList = function() {
  return this.setRelatedIdsList([]);
};


/**
 * optional Recipients recipients = 2;
 * @return {?proto.email.Recipients}
 */
proto.email.NewEmail.prototype.getRecipients = function() {
  return /** @type{?proto.email.Recipients} */ (
    jspb.Message.getWrapperField(this, proto.email.Recipients, 2));
};


/**
 * @param {?proto.email.Recipients|undefined} value
 * @return {!proto.email.NewEmail} returns this
*/
proto.email.NewEmail.prototype.setRecipients = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.email.NewEmail} returns this
 */
proto.email.NewEmail.prototype.clearRecipients = function() {
  return this.setRecipients(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.email.NewEmail.prototype.hasRecipients = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional EmailDetails details = 3;
 * @return {?proto.email.EmailDetails}
 */
proto.email.NewEmail.prototype.getDetails = function() {
  return /** @type{?proto.email.EmailDetails} */ (
    jspb.Message.getWrapperField(this, proto.email.EmailDetails, 3));
};


/**
 * @param {?proto.email.EmailDetails|undefined} value
 * @return {!proto.email.NewEmail} returns this
*/
proto.email.NewEmail.prototype.setDetails = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.email.NewEmail} returns this
 */
proto.email.NewEmail.prototype.clearDetails = function() {
  return this.setDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.email.NewEmail.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp send_at_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.email.NewEmail.prototype.getSendAtTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.email.NewEmail} returns this
*/
proto.email.NewEmail.prototype.setSendAtTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.email.NewEmail} returns this
 */
proto.email.NewEmail.prototype.clearSendAtTime = function() {
  return this.setSendAtTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.email.NewEmail.prototype.hasSendAtTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional EmailInternalDetails internal_details = 5;
 * @return {?proto.email.EmailInternalDetails}
 */
proto.email.NewEmail.prototype.getInternalDetails = function() {
  return /** @type{?proto.email.EmailInternalDetails} */ (
    jspb.Message.getWrapperField(this, proto.email.EmailInternalDetails, 5));
};


/**
 * @param {?proto.email.EmailInternalDetails|undefined} value
 * @return {!proto.email.NewEmail} returns this
*/
proto.email.NewEmail.prototype.setInternalDetails = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.email.NewEmail} returns this
 */
proto.email.NewEmail.prototype.clearInternalDetails = function() {
  return this.setInternalDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.email.NewEmail.prototype.hasInternalDetails = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.email.EmailDetails.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.email.EmailDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.email.EmailDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.email.EmailDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.email.EmailDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    from: jspb.Message.getFieldWithDefault(msg, 1, ""),
    subject: jspb.Message.getFieldWithDefault(msg, 2, ""),
    contentList: jspb.Message.toObjectList(msg.getContentList(),
    proto.email.EmailDetails.Content.toObject, includeInstance),
    templateId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    substitutionsMap: (f = msg.getSubstitutionsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.email.EmailDetails}
 */
proto.email.EmailDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.email.EmailDetails;
  return proto.email.EmailDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.email.EmailDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.email.EmailDetails}
 */
proto.email.EmailDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setFrom(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubject(value);
      break;
    case 3:
      var value = new proto.email.EmailDetails.Content;
      reader.readMessage(value,proto.email.EmailDetails.Content.deserializeBinaryFromReader);
      msg.addContent(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTemplateId(value);
      break;
    case 5:
      var value = msg.getSubstitutionsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.email.EmailDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.email.EmailDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.email.EmailDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.email.EmailDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFrom();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSubject();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getContentList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.email.EmailDetails.Content.serializeBinaryToWriter
    );
  }
  f = message.getTemplateId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSubstitutionsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(5, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.email.EmailDetails.Content.prototype.toObject = function(opt_includeInstance) {
  return proto.email.EmailDetails.Content.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.email.EmailDetails.Content} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.email.EmailDetails.Content.toObject = function(includeInstance, msg) {
  var f, obj = {
    mimeType: jspb.Message.getFieldWithDefault(msg, 1, ""),
    value: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.email.EmailDetails.Content}
 */
proto.email.EmailDetails.Content.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.email.EmailDetails.Content;
  return proto.email.EmailDetails.Content.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.email.EmailDetails.Content} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.email.EmailDetails.Content}
 */
proto.email.EmailDetails.Content.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMimeType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.email.EmailDetails.Content.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.email.EmailDetails.Content.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.email.EmailDetails.Content} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.email.EmailDetails.Content.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMimeType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string mime_type = 1;
 * @return {string}
 */
proto.email.EmailDetails.Content.prototype.getMimeType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.email.EmailDetails.Content} returns this
 */
proto.email.EmailDetails.Content.prototype.setMimeType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string value = 2;
 * @return {string}
 */
proto.email.EmailDetails.Content.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.email.EmailDetails.Content} returns this
 */
proto.email.EmailDetails.Content.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string from = 1;
 * @return {string}
 */
proto.email.EmailDetails.prototype.getFrom = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.email.EmailDetails} returns this
 */
proto.email.EmailDetails.prototype.setFrom = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string subject = 2;
 * @return {string}
 */
proto.email.EmailDetails.prototype.getSubject = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.email.EmailDetails} returns this
 */
proto.email.EmailDetails.prototype.setSubject = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated Content content = 3;
 * @return {!Array<!proto.email.EmailDetails.Content>}
 */
proto.email.EmailDetails.prototype.getContentList = function() {
  return /** @type{!Array<!proto.email.EmailDetails.Content>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.email.EmailDetails.Content, 3));
};


/**
 * @param {!Array<!proto.email.EmailDetails.Content>} value
 * @return {!proto.email.EmailDetails} returns this
*/
proto.email.EmailDetails.prototype.setContentList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.email.EmailDetails.Content=} opt_value
 * @param {number=} opt_index
 * @return {!proto.email.EmailDetails.Content}
 */
proto.email.EmailDetails.prototype.addContent = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.email.EmailDetails.Content, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.email.EmailDetails} returns this
 */
proto.email.EmailDetails.prototype.clearContentList = function() {
  return this.setContentList([]);
};


/**
 * optional string template_id = 4;
 * @return {string}
 */
proto.email.EmailDetails.prototype.getTemplateId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.email.EmailDetails} returns this
 */
proto.email.EmailDetails.prototype.setTemplateId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * map<string, string> substitutions = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.email.EmailDetails.prototype.getSubstitutionsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 5, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.email.EmailDetails} returns this
 */
proto.email.EmailDetails.prototype.clearSubstitutionsMap = function() {
  this.getSubstitutionsMap().clear();
  return this;};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.email.Recipients.repeatedFields_ = [1,2,3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.email.Recipients.prototype.toObject = function(opt_includeInstance) {
  return proto.email.Recipients.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.email.Recipients} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.email.Recipients.toObject = function(includeInstance, msg) {
  var f, obj = {
    toList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    ccList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    bccList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.email.Recipients}
 */
proto.email.Recipients.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.email.Recipients;
  return proto.email.Recipients.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.email.Recipients} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.email.Recipients}
 */
proto.email.Recipients.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTo(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addCc(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addBcc(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.email.Recipients.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.email.Recipients.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.email.Recipients} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.email.Recipients.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getToList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getCcList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getBccList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * repeated string to = 1;
 * @return {!Array<string>}
 */
proto.email.Recipients.prototype.getToList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.email.Recipients} returns this
 */
proto.email.Recipients.prototype.setToList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.email.Recipients} returns this
 */
proto.email.Recipients.prototype.addTo = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.email.Recipients} returns this
 */
proto.email.Recipients.prototype.clearToList = function() {
  return this.setToList([]);
};


/**
 * repeated string cc = 2;
 * @return {!Array<string>}
 */
proto.email.Recipients.prototype.getCcList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.email.Recipients} returns this
 */
proto.email.Recipients.prototype.setCcList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.email.Recipients} returns this
 */
proto.email.Recipients.prototype.addCc = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.email.Recipients} returns this
 */
proto.email.Recipients.prototype.clearCcList = function() {
  return this.setCcList([]);
};


/**
 * repeated string bcc = 3;
 * @return {!Array<string>}
 */
proto.email.Recipients.prototype.getBccList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.email.Recipients} returns this
 */
proto.email.Recipients.prototype.setBccList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.email.Recipients} returns this
 */
proto.email.Recipients.prototype.addBcc = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.email.Recipients} returns this
 */
proto.email.Recipients.prototype.clearBccList = function() {
  return this.setBccList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.email.Email.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.email.Email.prototype.toObject = function(opt_includeInstance) {
  return proto.email.Email.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.email.Email} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.email.Email.toObject = function(includeInstance, msg) {
  var f, obj = {
    emailId: (f = msg.getEmailId()) && proto_common_objectID_pb.ObjectID.toObject(includeInstance, f),
    relatedIdsList: jspb.Message.toObjectList(msg.getRelatedIdsList(),
    proto_common_objectID_pb.ObjectID.toObject, includeInstance),
    recipients: (f = msg.getRecipients()) && proto.email.Recipients.toObject(includeInstance, f),
    details: (f = msg.getDetails()) && proto.email.EmailDetails.toObject(includeInstance, f),
    sendAtTime: (f = msg.getSendAtTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    submissionTime: (f = msg.getSubmissionTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    submissionError: (f = msg.getSubmissionError()) && proto.email.Email.SubmissionError.toObject(includeInstance, f),
    lease: (f = msg.getLease()) && proto.email.Email.SubmissonLease.toObject(includeInstance, f),
    internalDetails: (f = msg.getInternalDetails()) && proto.email.EmailInternalDetails.toObject(includeInstance, f),
    crudFields: (f = msg.getCrudFields()) && proto_common_crudFields_pb.CRUDFields.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.email.Email}
 */
proto.email.Email.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.email.Email;
  return proto.email.Email.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.email.Email} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.email.Email}
 */
proto.email.Email.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.setEmailId(value);
      break;
    case 2:
      var value = new proto_common_objectID_pb.ObjectID;
      reader.readMessage(value,proto_common_objectID_pb.ObjectID.deserializeBinaryFromReader);
      msg.addRelatedIds(value);
      break;
    case 3:
      var value = new proto.email.Recipients;
      reader.readMessage(value,proto.email.Recipients.deserializeBinaryFromReader);
      msg.setRecipients(value);
      break;
    case 4:
      var value = new proto.email.EmailDetails;
      reader.readMessage(value,proto.email.EmailDetails.deserializeBinaryFromReader);
      msg.setDetails(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSendAtTime(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setSubmissionTime(value);
      break;
    case 7:
      var value = new proto.email.Email.SubmissionError;
      reader.readMessage(value,proto.email.Email.SubmissionError.deserializeBinaryFromReader);
      msg.setSubmissionError(value);
      break;
    case 8:
      var value = new proto.email.Email.SubmissonLease;
      reader.readMessage(value,proto.email.Email.SubmissonLease.deserializeBinaryFromReader);
      msg.setLease(value);
      break;
    case 9:
      var value = new proto.email.EmailInternalDetails;
      reader.readMessage(value,proto.email.EmailInternalDetails.deserializeBinaryFromReader);
      msg.setInternalDetails(value);
      break;
    case 10:
      var value = new proto_common_crudFields_pb.CRUDFields;
      reader.readMessage(value,proto_common_crudFields_pb.CRUDFields.deserializeBinaryFromReader);
      msg.setCrudFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.email.Email.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.email.Email.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.email.Email} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.email.Email.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmailId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getRelatedIdsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto_common_objectID_pb.ObjectID.serializeBinaryToWriter
    );
  }
  f = message.getRecipients();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.email.Recipients.serializeBinaryToWriter
    );
  }
  f = message.getDetails();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.email.EmailDetails.serializeBinaryToWriter
    );
  }
  f = message.getSendAtTime();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSubmissionTime();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getSubmissionError();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.email.Email.SubmissionError.serializeBinaryToWriter
    );
  }
  f = message.getLease();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      proto.email.Email.SubmissonLease.serializeBinaryToWriter
    );
  }
  f = message.getInternalDetails();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      proto.email.EmailInternalDetails.serializeBinaryToWriter
    );
  }
  f = message.getCrudFields();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      proto_common_crudFields_pb.CRUDFields.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.email.Email.SubmissionError.prototype.toObject = function(opt_includeInstance) {
  return proto.email.Email.SubmissionError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.email.Email.SubmissionError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.email.Email.SubmissionError.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, 0),
    status: jspb.Message.getFieldWithDefault(msg, 2, ""),
    message: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.email.Email.SubmissionError}
 */
proto.email.Email.SubmissionError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.email.Email.SubmissionError;
  return proto.email.Email.SubmissionError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.email.Email.SubmissionError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.email.Email.SubmissionError}
 */
proto.email.Email.SubmissionError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.email.Email.SubmissionError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.email.Email.SubmissionError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.email.Email.SubmissionError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.email.Email.SubmissionError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional int32 code = 1;
 * @return {number}
 */
proto.email.Email.SubmissionError.prototype.getCode = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.email.Email.SubmissionError} returns this
 */
proto.email.Email.SubmissionError.prototype.setCode = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string status = 2;
 * @return {string}
 */
proto.email.Email.SubmissionError.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.email.Email.SubmissionError} returns this
 */
proto.email.Email.SubmissionError.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string message = 3;
 * @return {string}
 */
proto.email.Email.SubmissionError.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.email.Email.SubmissionError} returns this
 */
proto.email.Email.SubmissionError.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.email.Email.SubmissonLease.prototype.toObject = function(opt_includeInstance) {
  return proto.email.Email.SubmissonLease.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.email.Email.SubmissonLease} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.email.Email.SubmissonLease.toObject = function(includeInstance, msg) {
  var f, obj = {
    leaseToken: jspb.Message.getFieldWithDefault(msg, 1, 0),
    leasedBy: jspb.Message.getFieldWithDefault(msg, 2, ""),
    leaseCount: jspb.Message.getFieldWithDefault(msg, 3, 0),
    leaseExpiryTime: (f = msg.getLeaseExpiryTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.email.Email.SubmissonLease}
 */
proto.email.Email.SubmissonLease.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.email.Email.SubmissonLease;
  return proto.email.Email.SubmissonLease.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.email.Email.SubmissonLease} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.email.Email.SubmissonLease}
 */
proto.email.Email.SubmissonLease.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLeaseToken(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeasedBy(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setLeaseCount(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setLeaseExpiryTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.email.Email.SubmissonLease.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.email.Email.SubmissonLease.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.email.Email.SubmissonLease} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.email.Email.SubmissonLease.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLeaseToken();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getLeasedBy();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLeaseCount();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getLeaseExpiryTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional int32 lease_token = 1;
 * @return {number}
 */
proto.email.Email.SubmissonLease.prototype.getLeaseToken = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.email.Email.SubmissonLease} returns this
 */
proto.email.Email.SubmissonLease.prototype.setLeaseToken = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string leased_by = 2;
 * @return {string}
 */
proto.email.Email.SubmissonLease.prototype.getLeasedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.email.Email.SubmissonLease} returns this
 */
proto.email.Email.SubmissonLease.prototype.setLeasedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int32 lease_count = 3;
 * @return {number}
 */
proto.email.Email.SubmissonLease.prototype.getLeaseCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.email.Email.SubmissonLease} returns this
 */
proto.email.Email.SubmissonLease.prototype.setLeaseCount = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp lease_expiry_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.email.Email.SubmissonLease.prototype.getLeaseExpiryTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.email.Email.SubmissonLease} returns this
*/
proto.email.Email.SubmissonLease.prototype.setLeaseExpiryTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.email.Email.SubmissonLease} returns this
 */
proto.email.Email.SubmissonLease.prototype.clearLeaseExpiryTime = function() {
  return this.setLeaseExpiryTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.email.Email.SubmissonLease.prototype.hasLeaseExpiryTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional common.ObjectID email_id = 1;
 * @return {?proto.common.ObjectID}
 */
proto.email.Email.prototype.getEmailId = function() {
  return /** @type{?proto.common.ObjectID} */ (
    jspb.Message.getWrapperField(this, proto_common_objectID_pb.ObjectID, 1));
};


/**
 * @param {?proto.common.ObjectID|undefined} value
 * @return {!proto.email.Email} returns this
*/
proto.email.Email.prototype.setEmailId = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.email.Email} returns this
 */
proto.email.Email.prototype.clearEmailId = function() {
  return this.setEmailId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.email.Email.prototype.hasEmailId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated common.ObjectID related_ids = 2;
 * @return {!Array<!proto.common.ObjectID>}
 */
proto.email.Email.prototype.getRelatedIdsList = function() {
  return /** @type{!Array<!proto.common.ObjectID>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_common_objectID_pb.ObjectID, 2));
};


/**
 * @param {!Array<!proto.common.ObjectID>} value
 * @return {!proto.email.Email} returns this
*/
proto.email.Email.prototype.setRelatedIdsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.common.ObjectID=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.ObjectID}
 */
proto.email.Email.prototype.addRelatedIds = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.common.ObjectID, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.email.Email} returns this
 */
proto.email.Email.prototype.clearRelatedIdsList = function() {
  return this.setRelatedIdsList([]);
};


/**
 * optional Recipients recipients = 3;
 * @return {?proto.email.Recipients}
 */
proto.email.Email.prototype.getRecipients = function() {
  return /** @type{?proto.email.Recipients} */ (
    jspb.Message.getWrapperField(this, proto.email.Recipients, 3));
};


/**
 * @param {?proto.email.Recipients|undefined} value
 * @return {!proto.email.Email} returns this
*/
proto.email.Email.prototype.setRecipients = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.email.Email} returns this
 */
proto.email.Email.prototype.clearRecipients = function() {
  return this.setRecipients(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.email.Email.prototype.hasRecipients = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional EmailDetails details = 4;
 * @return {?proto.email.EmailDetails}
 */
proto.email.Email.prototype.getDetails = function() {
  return /** @type{?proto.email.EmailDetails} */ (
    jspb.Message.getWrapperField(this, proto.email.EmailDetails, 4));
};


/**
 * @param {?proto.email.EmailDetails|undefined} value
 * @return {!proto.email.Email} returns this
*/
proto.email.Email.prototype.setDetails = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.email.Email} returns this
 */
proto.email.Email.prototype.clearDetails = function() {
  return this.setDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.email.Email.prototype.hasDetails = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp send_at_time = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.email.Email.prototype.getSendAtTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.email.Email} returns this
*/
proto.email.Email.prototype.setSendAtTime = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.email.Email} returns this
 */
proto.email.Email.prototype.clearSendAtTime = function() {
  return this.setSendAtTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.email.Email.prototype.hasSendAtTime = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional google.protobuf.Timestamp submission_time = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.email.Email.prototype.getSubmissionTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.email.Email} returns this
*/
proto.email.Email.prototype.setSubmissionTime = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.email.Email} returns this
 */
proto.email.Email.prototype.clearSubmissionTime = function() {
  return this.setSubmissionTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.email.Email.prototype.hasSubmissionTime = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional SubmissionError submission_error = 7;
 * @return {?proto.email.Email.SubmissionError}
 */
proto.email.Email.prototype.getSubmissionError = function() {
  return /** @type{?proto.email.Email.SubmissionError} */ (
    jspb.Message.getWrapperField(this, proto.email.Email.SubmissionError, 7));
};


/**
 * @param {?proto.email.Email.SubmissionError|undefined} value
 * @return {!proto.email.Email} returns this
*/
proto.email.Email.prototype.setSubmissionError = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.email.Email} returns this
 */
proto.email.Email.prototype.clearSubmissionError = function() {
  return this.setSubmissionError(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.email.Email.prototype.hasSubmissionError = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional SubmissonLease lease = 8;
 * @return {?proto.email.Email.SubmissonLease}
 */
proto.email.Email.prototype.getLease = function() {
  return /** @type{?proto.email.Email.SubmissonLease} */ (
    jspb.Message.getWrapperField(this, proto.email.Email.SubmissonLease, 8));
};


/**
 * @param {?proto.email.Email.SubmissonLease|undefined} value
 * @return {!proto.email.Email} returns this
*/
proto.email.Email.prototype.setLease = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.email.Email} returns this
 */
proto.email.Email.prototype.clearLease = function() {
  return this.setLease(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.email.Email.prototype.hasLease = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional EmailInternalDetails internal_details = 9;
 * @return {?proto.email.EmailInternalDetails}
 */
proto.email.Email.prototype.getInternalDetails = function() {
  return /** @type{?proto.email.EmailInternalDetails} */ (
    jspb.Message.getWrapperField(this, proto.email.EmailInternalDetails, 9));
};


/**
 * @param {?proto.email.EmailInternalDetails|undefined} value
 * @return {!proto.email.Email} returns this
*/
proto.email.Email.prototype.setInternalDetails = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.email.Email} returns this
 */
proto.email.Email.prototype.clearInternalDetails = function() {
  return this.setInternalDetails(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.email.Email.prototype.hasInternalDetails = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional common.CRUDFields crud_fields = 10;
 * @return {?proto.common.CRUDFields}
 */
proto.email.Email.prototype.getCrudFields = function() {
  return /** @type{?proto.common.CRUDFields} */ (
    jspb.Message.getWrapperField(this, proto_common_crudFields_pb.CRUDFields, 10));
};


/**
 * @param {?proto.common.CRUDFields|undefined} value
 * @return {!proto.email.Email} returns this
*/
proto.email.Email.prototype.setCrudFields = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.email.Email} returns this
 */
proto.email.Email.prototype.clearCrudFields = function() {
  return this.setCrudFields(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.email.Email.prototype.hasCrudFields = function() {
  return jspb.Message.getField(this, 10) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.email.EmailInternalDetails.prototype.toObject = function(opt_includeInstance) {
  return proto.email.EmailInternalDetails.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.email.EmailInternalDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.email.EmailInternalDetails.toObject = function(includeInstance, msg) {
  var f, obj = {
    isInternal: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    sendgridParameters: (f = msg.getSendgridParameters()) && proto.email.EmailInternalDetails.SendgridParameters.toObject(includeInstance, f),
    uniqueIdentifier: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.email.EmailInternalDetails}
 */
proto.email.EmailInternalDetails.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.email.EmailInternalDetails;
  return proto.email.EmailInternalDetails.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.email.EmailInternalDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.email.EmailInternalDetails}
 */
proto.email.EmailInternalDetails.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsInternal(value);
      break;
    case 2:
      var value = new proto.email.EmailInternalDetails.SendgridParameters;
      reader.readMessage(value,proto.email.EmailInternalDetails.SendgridParameters.deserializeBinaryFromReader);
      msg.setSendgridParameters(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUniqueIdentifier(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.email.EmailInternalDetails.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.email.EmailInternalDetails.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.email.EmailInternalDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.email.EmailInternalDetails.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsInternal();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getSendgridParameters();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.email.EmailInternalDetails.SendgridParameters.serializeBinaryToWriter
    );
  }
  f = message.getUniqueIdentifier();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.email.EmailInternalDetails.SendgridParameters.prototype.toObject = function(opt_includeInstance) {
  return proto.email.EmailInternalDetails.SendgridParameters.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.email.EmailInternalDetails.SendgridParameters} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.email.EmailInternalDetails.SendgridParameters.toObject = function(includeInstance, msg) {
  var f, obj = {
    lastBatchId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.email.EmailInternalDetails.SendgridParameters}
 */
proto.email.EmailInternalDetails.SendgridParameters.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.email.EmailInternalDetails.SendgridParameters;
  return proto.email.EmailInternalDetails.SendgridParameters.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.email.EmailInternalDetails.SendgridParameters} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.email.EmailInternalDetails.SendgridParameters}
 */
proto.email.EmailInternalDetails.SendgridParameters.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastBatchId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.email.EmailInternalDetails.SendgridParameters.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.email.EmailInternalDetails.SendgridParameters.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.email.EmailInternalDetails.SendgridParameters} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.email.EmailInternalDetails.SendgridParameters.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getLastBatchId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string last_batch_id = 1;
 * @return {string}
 */
proto.email.EmailInternalDetails.SendgridParameters.prototype.getLastBatchId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.email.EmailInternalDetails.SendgridParameters} returns this
 */
proto.email.EmailInternalDetails.SendgridParameters.prototype.setLastBatchId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool is_internal = 1;
 * @return {boolean}
 */
proto.email.EmailInternalDetails.prototype.getIsInternal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.email.EmailInternalDetails} returns this
 */
proto.email.EmailInternalDetails.prototype.setIsInternal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional SendgridParameters sendgrid_parameters = 2;
 * @return {?proto.email.EmailInternalDetails.SendgridParameters}
 */
proto.email.EmailInternalDetails.prototype.getSendgridParameters = function() {
  return /** @type{?proto.email.EmailInternalDetails.SendgridParameters} */ (
    jspb.Message.getWrapperField(this, proto.email.EmailInternalDetails.SendgridParameters, 2));
};


/**
 * @param {?proto.email.EmailInternalDetails.SendgridParameters|undefined} value
 * @return {!proto.email.EmailInternalDetails} returns this
*/
proto.email.EmailInternalDetails.prototype.setSendgridParameters = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.email.EmailInternalDetails} returns this
 */
proto.email.EmailInternalDetails.prototype.clearSendgridParameters = function() {
  return this.setSendgridParameters(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.email.EmailInternalDetails.prototype.hasSendgridParameters = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string unique_identifier = 3;
 * @return {string}
 */
proto.email.EmailInternalDetails.prototype.getUniqueIdentifier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.email.EmailInternalDetails} returns this
 */
proto.email.EmailInternalDetails.prototype.setUniqueIdentifier = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


goog.object.extend(exports, proto.email);
